export const UPDATE_EVALUATION = 'UPDATE_EVALUATION';

export const GET_EVALUATION_REQUEST = 'GET_EVALUATION_REQUEST';
export const GET_EVALUATION_SUCCESS = 'GET_EVALUATION_SUCCESS';
export const GET_EVALUATION_FAIL = 'GET_EVALUATION_FAIL';

export const GET_ALL_EVALUATIONS_REQUEST = 'GET_ALL_EVALUATIONS_REQUEST';
export const GET_ALL_EVALUATIONS_SUCCESS = 'GET_ALL_EVALUATIONS_SUCCESS';
export const GET_ALL_EVALUATIONS_FAIL = 'GET_ALL_EVALUATIONS_FAIL';

export const GET_EVALUATIONS_BY_TYPE_REQUEST = 'GET_EVALUATIONS_BY_TYPE_REQUEST';
export const GET_EVALUATIONS_BY_TYPE_SUCCESS = 'GET_EVALUATIONS_BY_TYPE_SUCCESS';
export const GET_EVALUATIONS_BY_TYPE_FAIL = 'GET_EVALUATIONS_BY_TYPE_FAIL';

export const CREATE_EVALUATION_REQUEST = 'CREATE_EVALUATION_REQUEST';
export const CREATE_EVALUATION_SUCCESS = 'CREATE_EVALUATION_SUCCESS';
export const CREATE_EVALUATION_FAIL = 'CREATE_EVALUATION_FAIL';

export const UPDATE_EVALUATION_REQUEST = 'UPDATE_EVALUATION_REQUEST';
export const UPDATE_EVALUATION_SUCCESS = 'UPDATE_EVALUATION_SUCCESS';
export const UPDATE_EVALUATION_FAIL = 'UPDATE_EVALUATION_FAIL';

export const DELETE_EVALUATION_REQUEST = 'DELETE_EVALUATION_REQUEST';
export const DELETE_EVALUATION_SUCCESS = 'DELETE_EVALUATION_SUCCESS';
export const DELETE_EVALUATION_FAIL = 'DELETE_EVALUATION_FAIL';

export const CHANGE_EVALUATION_STATUS_REQUEST = 'CHANGE_EVALUATION_STATUS_REQUEST';
export const CHANGE_EVALUATION_STATUS_SUCCESS = 'CHANGE_EVALUATION_STATUS_SUCCESS';
export const CHANGE_EVALUATION_STATUS_FAIL = 'CHANGE_EVALUATION_STATUS_FAIL';

export const SET_EVALUATION_LOADING = 'SET_EVALUATION_LOADING';
export const CLEAR_EVALUATION_ERROR = 'CLEAR_EVALUATION_ERROR';

// ========================================
// ACTION CREATORS
// ========================================

export const updateEvaluation = (evaluation) => ({
    type: UPDATE_EVALUATION,
    evaluation
});

export const getEvaluationRequest = (evaluationId) => ({
    type: GET_EVALUATION_REQUEST,
    payload: { evaluationId }
});

export const getEvaluationSuccess = (evaluation) => ({
    type: GET_EVALUATION_SUCCESS,
    payload: evaluation
});

export const getEvaluationFail = (error) => ({
    type: GET_EVALUATION_FAIL,
    error
});

export const getAllEvaluationsRequest = () => ({
    type: GET_ALL_EVALUATIONS_REQUEST
});

export const getAllEvaluationsSuccess = (evaluations) => ({
    type: GET_ALL_EVALUATIONS_SUCCESS,
    payload: evaluations
});

export const getAllEvaluationsFail = (error) => ({
    type: GET_ALL_EVALUATIONS_FAIL,
    error
});

export const getEvaluationsByTypeRequest = (typeCode) => ({
    type: GET_EVALUATIONS_BY_TYPE_REQUEST,
    payload: { typeCode }
});

export const getEvaluationsByTypeSuccess = (evaluations) => ({
    type: GET_EVALUATIONS_BY_TYPE_SUCCESS,
    payload: evaluations
});

export const getEvaluationsByTypeFail = (error) => ({
    type: GET_EVALUATIONS_BY_TYPE_FAIL,
    error
});

export const createEvaluationRequest = (evaluationData, history) => ({
    type: CREATE_EVALUATION_REQUEST,
    payload: evaluationData,
    history
});

export const createEvaluationSuccess = (evaluation) => ({
    type: CREATE_EVALUATION_SUCCESS,
    payload: evaluation
});

export const createEvaluationFail = (error) => ({
    type: CREATE_EVALUATION_FAIL,
    error
});

export const updateEvaluationRequest = (evaluationId, evaluationData, history) => ({
    type: UPDATE_EVALUATION_REQUEST,
    payload: { evaluationId, evaluationData },
    history
});

export const updateEvaluationSuccess = (evaluation) => ({
    type: UPDATE_EVALUATION_SUCCESS,
    payload: evaluation
});

export const updateEvaluationFail = (error) => ({
    type: UPDATE_EVALUATION_FAIL,
    error
});

export const deleteEvaluationRequest = (evaluationId, history) => ({
    type: DELETE_EVALUATION_REQUEST,
    payload: { evaluationId },
    history
});

export const deleteEvaluationSuccess = (evaluationId) => ({
    type: DELETE_EVALUATION_SUCCESS,
    payload: { evaluationId }
});

export const deleteEvaluationFail = (error) => ({
    type: DELETE_EVALUATION_FAIL,
    error
});

export const changeEvaluationStatusRequest = (evaluationId, status) => ({
    type: CHANGE_EVALUATION_STATUS_REQUEST,
    payload: { evaluationId, status }
});

export const changeEvaluationStatusSuccess = (evaluation) => ({
    type: CHANGE_EVALUATION_STATUS_SUCCESS,
    payload: evaluation
});

export const changeEvaluationStatusFail = (error) => ({
    type: CHANGE_EVALUATION_STATUS_FAIL,
    error
});

export const setEvaluationLoading = (loading) => ({
    type: SET_EVALUATION_LOADING,
    payload: loading
});

export const clearEvaluationError = () => ({
    type: CLEAR_EVALUATION_ERROR
});